const init = () => {
  const impacts = document.getElementById('organization-impacts')
  const infinite = document.getElementById('infinite-impacts')

  let fetching = false
  let page = 1

  const fetchImpacts = async () => {
    if (fetching) return
    fetching = true

    try {
      const response = await fetch(`${location.pathname}?page=${page + 1}`, {
        headers: { Accept: 'application/json' }
      })
      const json = await response.json()
      impacts.insertAdjacentHTML('beforeend', json.impacts)
      page++

      if (json.last_page)
        observer.disconnect()
    } finally {
      fetching = false
    }
  }

  const handleIntersection = entries =>
    entries.forEach(entry => {
      if (entry.isIntersecting)
        fetchImpacts()
    })

  const observer = new IntersectionObserver(handleIntersection)
  observer.observe(infinite)

  infinite.style.height = '1px'
  infinite.style.marginBottom = '-1px'
}

document.addEventListener('DOMContentLoaded', init)
